
import React from 'react';
import { useSpring, animated } from 'react-spring';

function About() {
  const fadeIn = useSpring({
    opacity: 1,
    from: { opacity: 0 },
  });
    return (
      <section className="about" id="about">
          <div className="row">
        <div className="image">
          <img src="./assests/about.jpeg" alt="about.jpeg" />
        </div>
        <div className="content">
          <h3>I'm Varun <span className="span">Walia</span></h3>
          <span class="tag">Pursuing My  Full Stack Web Development Course</span>
          <p>I am a Full-Stack developer based in Rajpura, India. 
            I have Completed my BJMC in from Punjbai University Patiala.
            I am very passionate about improving my coding skills & developing applications & websites.
            I build WebApps and Websites using MERN Stack.
            Working for myself to improve my skills.
            Love to build Full-Stack clones. </p>
            <div class="box-container">
              <div class="box">
                <p><span> age: </span> 30</p>
                <p><span> phone : </span> +91 XXX-XXX-XXXX</p>
              </div>
              <div class="box">
                <p><span> email : </span> walia3616@gmail.com</p>
                <p><span> place : </span> Rajpura,Punajb India</p>
              </div>
          </div>
            </div>
        </div>
      </section>
    );
  }
  export default About;
  